import React from "react";
import settingable from "fantastic/components/hoc/settingable";
import SingleNumberSetting from "fantastic/components/common/controls/SingleNumberSetting";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";

const TableSettings = ({ update, selected, selectedNode: { rows, src = "" }}) => {

  const onChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  const hasLiquidTags = JSON.stringify(rows).includes('{{');

  return (
    <div>
      { hasLiquidTags && 
      <SingleStringSetting
        value={src}
        onChange={onChange('src')}
        label={i18n.t('products')}
        placeholder={i18n.t('products_placeholder')}
      />}
    </div>
  );
};

export default settingable("background", "visibility")(TableSettings);
